import http from "../utils/http";
import { MemberResponse } from "./MembersService";
import { GETListResponse } from "./SubscriptionServices";

export interface DietPlanFace {
  id: string;
  user: MemberResponse;
  createdAt: string;
  updatedAt: string;
  requestStatus: "REQUESTED" | "IN_PROGRESS" | "ADDRESSED";
  comments: string;
  dietPlanUrl: string;
}

const GetDietPlanRequests = async ({
  page,
  size,
}: {
  page: number;
  size: number;
}): Promise<GETListResponse<DietPlanFace>> => {
  const url = `/admin/diet-plan-requests?page=${page - 1}&size=${size}`;

  const response = await http.get({ path: url });
  if (response.status == 200 && response.data) {
    return response.data as GETListResponse<DietPlanFace>;
  } else {
    throw new Error(`Error fetching subscriptions: ${response.statusText}`);
  }
};

const ChangeStatusOfRequest = async ({
  id,
  status,
}: {
  id: string;
  status: string;
}): Promise<number> => {
  const urlPath = `/admin/diet-plan-requests/status?id=${id}&status=${status}`;
  const response = await http.put({ path: urlPath, body: {} });
  if (response.status == 204) {
    return 204;
  } else {
    return 401;
  }
};

export const sendPutPdfRequest = async ({
  signUrl,
  file,
}: {
  signUrl: string;
  file: File;
}): Promise<Response> => {
  const headers = {
    "Content-Type": "application/pdf",
    // "x-amz-acl": "public-read",
  };

  const options: RequestInit = {
    method: "PUT",
    headers: headers,
    body: file,
  };

  const response = await fetch(signUrl, options);
  return response;
};

const GetSignUrlForDietPlanUpload = async ({
  name,
  userId,
}: {
  name: string;
  userId: string;
}): Promise<string> => {
  const urlPath = `/admin/diet-plan-requests/upload-plan?fileName=${name}&userId=${userId}`;
  const GetSignUrl = await http.get({ path: urlPath });

  if (GetSignUrl.status == 200 && (GetSignUrl.data.data as string)) {
    return GetSignUrl.data.data;
  } else {
    throw new Error(`Error fetching Sign Url : ${GetSignUrl.statusText}`);
  }
};

const UploadDietPlan = async ({
  requestId,
  comment,
  docUrl,
}: {
  requestId: string;
  comment: string;
  docUrl: string;
}): Promise<number> => {
  const urlPath = `/admin/diet-plan-requests/address-request`;

  const body = {
    requestId,
    comment,
    docUrl,
  };

  const result = await http.put({ path: urlPath, body });
  if (result.status == 204) {
    return 204;
  } else {
    return 401;
  }
};
export {
  GetDietPlanRequests,
  ChangeStatusOfRequest,
  GetSignUrlForDietPlanUpload,
  UploadDietPlan,
};
